import Animation from './Animation';

const activeShakes = new WeakMap();
const OFFSETS = [
  [0, 0], [0.3, 0.8], [-0.9, -0.4], [1, 0.5], [-0.7, -0.7],
  [0.8, 0.3], [-1, 0.6], [0.6, -0.5], [-0.8, 0.4], [0.5, -0.6],
  [-0.6, 0.3], [0.7, -0.3], [-0.4, 0.4], [0.3, -0.2], [0, 0]
];

export default class Quake extends Animation {
  constructor(master, power) {
    const strength = Math.max(0, Number(power) || 0);
    const intensity = Math.min(1, Math.log2(1 + strength / 4) / 5);
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    super(master, strength > 0 && !reducedMotion ? 360 + intensity * 360 : 0);
    this.amplitude = strength > 0 ? 2 + intensity * 16 : 0;
  }

  run() {
    if (!this.time) return;
    const scene = document.getElementById('scene');
    if (!scene) return;
    const viewport = Math.max(1, Math.min(window.innerWidth, window.innerHeight));
    const amplitude = Math.min(this.amplitude, viewport * 0.025);
    // Move the world together; character animations and the HUD keep their own transforms.
    scene.querySelectorAll('.scene-background, .game-champion, .game-companion, .game-enemies').forEach(element => {
      if (!element.animate) return;
      activeShakes.get(element)?.cancel();
      const background = element.classList.contains('scene-background');
      const frames = OFFSETS.map(([x, y], index) => {
        const offset = index / (OFFSETS.length - 1);
        const decay = Math.pow(1 - offset, 1.5);
        const dx = x * amplitude * decay;
        const dy = y * amplitude * decay;
        return {
          offset,
          translate: `${dx.toFixed(2)}px ${dy.toFixed(2)}px`,
          // Overscan the background just enough to avoid revealing its edges.
          ...(background ? { scale: 1 + 2 * Math.max(Math.abs(dx), Math.abs(dy)) / viewport } : {})
        };
      });
      const animation = element.animate(frames, { duration: this.time, easing: 'linear', fill: 'none' });
      activeShakes.set(element, animation);
      const clear = () => {
        if (activeShakes.get(element) === animation) activeShakes.delete(element);
      };
      animation.onfinish = clear;
      animation.oncancel = clear;
    });
  }
}
